import React, { useRef, useState } from 'react';
import { Select } from 'antd';
import dayjs from 'dayjs';
import AddOrEdit from './AddOrEdit';
import { SActionBtn, SLowcodeList, STableActions } from 'shj-components';
import { httpAchieveDepartmentDelete, httpAchievementDateList, httpAchievementDeptDetails, httpAchievementDeptList, httpCompanyList, httpDeptFilter, httpDictServ, httpUpdateStatus } from '@/services/customerServices';
import { configs } from './config';
import {getUserIdentities} from "@/services/user.ts";
const { Option } = Select;
import { getUser } from '@/common/utils.ts'
/**
 * 部门相关
 * @returns 
 */
const Dept: React.FC<any> = () => {
  const compony = useRef<any>([]);
  const category = useRef<any>([]);
  const dept = useRef<any>([]);
  const listRef = useRef<any>();
  const [yearMonthArr, setMonthYearArr] = useState<any[]>([]);
  const [id, setId] = useState<number | undefined>(undefined);
  const [editData, setEditData] = useState<any>({});
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState(false)
  const userInfo: { [key: string]: any } = getUser()

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values;
        const formData = {
          ...query,
          performanceCycleMonthId: query.yearMonth ? query.yearMonth.split('*')[1] : ''
        }
        const resData = await httpAchievementDeptList(current, pageSize, formData)
        resolve(resData);
      } catch {
        reject({ success: false });
      }
    });
  };
  const onAdd = () => {
    setId(undefined);
    setIsVisible(true);
    setEditData({});
  };
  const getProductionType = () => {
    return new Promise(async (resolve) => {
      resolve({
        DRAFT: '草稿',
        PENDING: '待审批',
        REJECT: '审核不通过',
        CONFIRM: '已确认',
      });
    });
  };

  const getCategory = () => {
    return new Promise(async (resolve) => {
      const resData: any = await httpDictServ({ parentKey: 'performanceType', enable: '1' })
      category.current = resData;
      resolve(resData);
    });
  };

  const getDept = () => {
    return new Promise(async (resolve) => {
      const resData: any = await httpDeptFilter({
        companyCodes: userInfo && userInfo?.companyId && [userInfo?.companyId],
        functionCodes: ['marketing', 'design', 'YLmarketing', 'YLsoftDecoration', 'team']
      })
      console.log('resData', resData);
      dept.current = resData;
      resolve(resData);
    });
  };

  const getCompany = () => {
    return new Promise(async (resolve) => {
      const companyList: any = await httpCompanyList()
      const companyTree: any[] = [{ title: '全部门店', val: [], key: '0-0', child: [] }];
      if (companyList.length) {
        for (let i = 0; i < companyList.length; i++) {
          companyList[i].title = companyList[i].name;
          companyList[i].val = companyList[i].id + '';
          companyList[i].key = companyList[i].val;
          companyTree[0].val.push(companyList[i].val);
          companyTree[0].child.push(companyList[i]);
        }
      }
      compony.current = companyTree
      resolve(companyTree[0].child);
    });
  };

  const getSelect = () => {
    return new Promise((resolve) => {
      Promise.all([getCompany(), getProductionType(), getCategory(), getDept()]).then((result: any) => {
        console.log('result[2]', result[2]);
        resolve({
          company: result[0],
          productType: result[1],
          category: result[2],
          dept: result[3],
        });
      });
    });
  };

  const onEdit = async (record: any, check: boolean) => {
    try {
      setLoading(true)
      setIsVisible(true);
      const resData: any = await httpAchievementDeptDetails(record.id)
      setEditData({ ...resData, check });
      setId(record.id);
      setLoading(false)
    } catch (error) {
      console.log('error', error);
      setLoading(false)
    }
  };

  const onSelectChange = () => {
    const _category = listRef.current.getSearch().getFieldValue('category');
    let _companyId = listRef.current.getSearch().getFieldValue('companyCode');
    listRef.current.getSearch()?.setFieldsValue({ yearMonth: undefined })
    if (_category && _companyId) {
      compony.current[0].child.map((item: any) => {
        if (item.code == _companyId) {
          _companyId = item.id;
        }
      });
      httpAchievementDateList({
        category: _category,
        companyId: _companyId,
      }).then((resp: any) => {
        setMonthYearArr(resp || []);
      })
    }
  };
  const changeStatus = (value: any, status: string) => {
    httpUpdateStatus({
      id: value.id,
      status: status,
    }).then(() => {
      listRef.current.reload();
    })
  };
  const del = (value: any) => {
    httpAchieveDepartmentDelete(value.id).then(() => {
      listRef.current.reload();
    })
  };
  const selectChange = (v: any) => {
    console.log(v, 'select')
    listRef.current.getSearch().setFieldsValue({ yearMonth: v });
  };
  const extension = {
    request: { fetchList, getSelect },
    events: { onAdd, onSelectChange },
    customRender: {
      selectRender() {
        return (
          <Select placeholder="请选择" allowClear onChange={(v) => selectChange(v)} disabled={!yearMonthArr.length}>
            {yearMonthArr.map((item: any, index: number) => {
              return (
                <Option
                  key={index}
                  value={
                    item.year ? dayjs(item.year + '-' + item.month, 'YYYY-MM').format('YYYY-MM') + '*' + item.id : ''
                  }
                >
                  {item.year ? dayjs(item.year + '-' + item.month, 'YYYY-MM').format('YYYY-MM') : '时间格式出错'}
                </Option>
              );
            })}
          </Select>
        );
      },
      actionTool(text: any, record: any) {
        return (
          <STableActions>
            {record.status == 'DRAFT' || record.status == 'REJECT' ? (
              <>
                <SActionBtn onClick={() => onEdit(record, false)}>编辑</SActionBtn>
                <SActionBtn title='确认提交吗？' confirm onClick={() => changeStatus(record, 'PENDING')} >提交</SActionBtn>
                <SActionBtn title='确认删除吗？' confirm onClick={() => del(record)}>删除</SActionBtn>
              </>
            ) : null}
            {record.status == 'PENDING'
              ?
              <>
                <SActionBtn title='确认通过吗？' confirm onClick={() => changeStatus(record, 'CONFIRM')} >通过</SActionBtn>
                <SActionBtn title='确认驳回吗？' confirm onClick={() => changeStatus(record, 'REJECT')}>驳回</SActionBtn>
              </>
              : null}
            {record.status == 'CONFIRM' ? <SActionBtn loading={loading} onClick={() => onEdit(record, true)}>查看</SActionBtn> : null}
          </STableActions>
        )
      },
    },
  };
  return (
    <>
      <SLowcodeList config={configs} ref={listRef} {...extension} />
      <AddOrEdit
        editData={editData}
        id={id}
        setVisible={setIsVisible}
        visible={isVisible}
        listRef={listRef}
        loaing={loading}
        deptRef={dept}
      />
    </>
  );
};

export default Dept;
